import React from "react";
import { Drawer } from 'components/common';
import PropTypes from "prop-types";
import { FaUserEdit } from "react-icons/fa";
import ContactForm from "./ContactForm";

/**
 * Slide-in Drawer wrapper around ContactForm for editing a contact in place
 * (no full-page navigation). The form is keyed by contact id and only mounted
 * while the drawer is open, so it always hydrates fresh from the latest record.
 */
const EditContactDrawer = ({ show, onHide, customer, contact, onSaved }) => (
  <Drawer
    show={show}
    onHide={onHide}
    title={<><FaUserEdit size={15} /> Edit Contact</>}
    width="46%"
    minWidth="460px"
    backdropClick={false}
  >
    {show && contact ? (
      <ContactForm
        key={contact.id}
        customer={customer}
        contact={contact}
        handleCancel={onHide}
        onSuccess={() => { onSaved?.(); onHide(); }}
      />
    ) : <></>}
  </Drawer>
);

EditContactDrawer.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  customer: PropTypes.object,
  contact: PropTypes.object,
  onSaved: PropTypes.func,
};

export default EditContactDrawer;
